import { NatObjectItemController } from "@natiwi/core/controllers/object-item.controller";
import { OrmDocumentItem } from "@natiwi/core/models/document-item";

export abstract class NatDocumentItemController<Model extends OrmDocumentItem> extends NatObjectItemController<Model>{

    constructor() {
        super();
    }
    
}